import React from 'react';
import { Logo } from '../../styles/navbar.style';
import AuthenticateLogo from '../../../../images/logos/authenticate_rgb.svg';
import { Link } from 'gatsby';

const BrandLogo = () => {
    return (
        <Link to="/">
            <Logo src={AuthenticateLogo} alt="authenticate-logo" />
        </Link>
    );
};

export default BrandLogo;
